import styled from "@emotion/styled";
import React, { ReactNode } from "react";

const StyleWrapper = styled.div<{ styleWrapper?: string }>`
  padding: 12px;
  border-radius: 8px;
  box-shadow: ${(props: any) => props.theme.colors.boxShadow};
  width: auto;
  height: auto;
  display: block;
  max-width: 100%;
  ${(props: any) => props.styleWrapper}
`;

const FieldWrapper = ({
  children,
  styleWrapper,
}: {
  children: ReactNode;
  styleWrapper?: string;
}) => {
  return <StyleWrapper styleWrapper={styleWrapper}>{children}</StyleWrapper>;
};

export default FieldWrapper;
